module.exports = __webpack_public_path__ + "img/40_00_055_900.927f1083.jpg";